import { render, staticRenderFns } from "./NameChange.vue?vue&type=template&id=09f5e41a&scoped=true&"
import script from "./NameChange.vue?vue&type=script&lang=js&"
export * from "./NameChange.vue?vue&type=script&lang=js&"
import style0 from "./NameChange.vue?vue&type=style&index=0&id=09f5e41a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f5e41a",
  null
  
)

export default component.exports